import { ReduxService } from 'dashboard-services/services';

import { groupsDatalakeActions } from 'actions/modules/datalake';

export const groupsInitialState = {
  selectedGroup: undefined
}

export default (state = groupsInitialState, action) => {
  switch (action.type) {
    case groupsDatalakeActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}